export const aboutData = {
  heroTitle: '关于韩漫网',
  heroSubtitle: '致力于为全球韩漫爱好者提供最优质的高清免费阅读体验',
  heroImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20of%20a%20cozy%20reading%20space%20with%20warm%20lighting%2C%20bookshelves%20filled%20with%20colorful%20manhwa%20volumes%2C%20comfortable%20armchair%2C%20soft%20cream%20and%20peach%20tones%2C%20peaceful%20and%20inviting%20atmosphere%2C%20digital%20art%20style%2C%20clean%20composition%2C%20wide%20format&width=1440&height=700&seq=about-hero-bg&orientation=landscape',
  brandStory: {
    title: '品牌故事',
    subtitle: '因为热爱，所以专注',
    paragraphs: [
      '韩漫网诞生于一群资深韩漫爱好者的共同梦想。在创立之初，我们发现国内缺乏一个真正专注于韩国漫画、同时提供高质量阅读体验的平台。要么画质模糊、要么更新迟缓、要么夹杂大量广告，这些痛点困扰着每一位韩漫读者。',
      '于是，我们决定亲手打造一个理想的韩漫阅读空间。从2019年的小团队开始，经过数年的坚持与打磨，韩漫网如今已经成长为拥有超过12,800部漫画作品、服务860万月活跃读者的专业韩漫平台。',
      '我们相信，好的漫画值得用最好的方式呈现。每一部上线作品都经过精心筛选和严格审核，确保画质高清、翻译精准。我们与韩国多家知名漫画平台和出版社建立了深度合作关系，为读者带来最新的优质内容。',
    ],
  },
  platformData: {
    title: '平台数据',
    subtitle: '用数字见证我们的成长',
    stats: [
      { value: '12,800', suffix: '+', label: '收录作品' },
      { value: '3,500', suffix: '+', label: '签约作者' },
      { value: '860', suffix: '万+', label: '月活跃读者' },
      { value: '98.6', suffix: '%', label: '好评率' },
    ],
  },
  coreValues: {
    title: '核心优势',
    items: [
      { icon: 'ri-shield-star-line', title: '高清画质', desc: '所有漫画均提供高清版本，每一帧画面都清晰锐利，完美还原原作的绘画细节和色彩表现。' },
      { icon: 'ri-flashlight-line', title: '极速更新', desc: '热门作品同步韩国原版更新进度，让国内读者与韩国读者同步追更，告别漫长的等待。' },
      { icon: 'ri-global-line', title: '海量资源', desc: '涵盖恋爱、奇幻、动作、悬疑等全类型漫画，从热门连载到经典完结，满足各种阅读偏好。' },
      { icon: 'ri-smartphone-line', title: '多端适配', desc: '完美适配电脑、平板和手机，无论在家还是通勤途中，都能享受流畅的阅读体验。' },
      { icon: 'ri-translate', title: '专业翻译', desc: '资深翻译团队层层把关，确保每一句对白自然流畅，还原原作的风格与韵味。' },
      { icon: 'ri-customer-service-2-line', title: '贴心服务', desc: '7x24小时客服支持，问题反馈即时处理，让每一位读者都能享受无忧的阅读时光。' },
    ],
  },
  contact: {
    title: '商务合作',
    subtitle: '期待与您携手，共创韩漫美好未来',
    description: '我们欢迎漫画作者、版权方、出版社及各类合作伙伴与我们联系。无论是内容授权、广告投放还是其他形式的商业合作，我们都有专业的团队为您提供最优的合作方案。',
    phone: '400-888-6666',
    email: 'hello@emenculture.com',
    address: '北京市朝阳区望京SOHO T1栋A座18层',
    workHours: '周一至周五 9:00 - 18:00',
  },
  timeline: {
    title: '发展历程',
    items: [
      { year: '2019', event: '韩漫网正式成立，首批上线500部漫画' },
      { year: '2020', event: '月活突破100万，与韩国三大漫画平台达成合作' },
      { year: '2021', event: '漫画总量突破5000部，推出移动端优化版本' },
      { year: '2022', event: '签约作者突破2000人，平台月活超过500万' },
      { year: '2023', event: '获得行业年度最佳漫画平台奖项' },
      { year: '2024', event: '月活突破860万，上线AI智能推荐系统' },
    ],
  },
};